import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@uw/core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '@uw-env/environment';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { AsyncPipe } from '@angular/common';

/**
 * @deprecated This is dead code can be removed as it is not being used anywhere.
 */
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [MatButton, MatIconButton, MatMenuTrigger, MatMenu, RouterLink, AsyncPipe, TranslateModule]
})
export class HeaderComponent implements OnInit {
  sidenav_toggleClass = 'sidenav-toggled';
  allowGroupTypeSwitch: boolean = false;
  isUserLoggedIn$: Observable<boolean> | undefined;

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }


  ngOnInit(): void {
    this.isUserLoggedIn$ = this.authService.getUserState().pipe(map(user => !!user));
  }

  toggleSideBar() {
    const body = document.getElementsByTagName('body')[0];
    const hasClass = body.classList.contains(this.sidenav_toggleClass);
    if (hasClass) {
      body.classList.remove(this.sidenav_toggleClass);
    } else {
      body.classList.add(this.sidenav_toggleClass);
    }
  }

  changeLang(e: Event) {
    e.preventDefault();
    const curLang = this.translateService.currentLang;
    this.authService
      .togglerLangugage(curLang === 'en' ? 'fr' : 'en')
      .subscribe((data) => {
        localStorage.setItem('lang', curLang === 'en' ? 'fr' : 'en');
        this.translateService.use(curLang === 'en' ? 'fr' : 'en');
        window.location.reload();
      });
  }

  onDonate() {
    this.router.navigate(['auth']);
  }

   //revert to disable SSO logout before release 6.5
  // logout() {
  //   let isSSOUser = this.authService.getUser()?.isSSOUser;
  //   if (isSSOUser){
  //     this.authService.sso_saml_logOut();
  //   } else {
  //     let lang = localStorage.getItem('lang');
  //     this.authService.logOut().subscribe(
  //       _ => {
  //         if (isSSOUser) {
  //           window.location.href = `${environment.donorSiteUrl}/main/sso-login?loggedout=true&isSSOUser=${isSSOUser}&lang=${lang}`;
  //         } else {
  //           window.location.href = `${environment.donorSiteUrl}?loggedout=true&lang=${lang}`;
  //         }
  //       }
  //     );
  //   }
  // }

  logout() {
    let isSSOUser = this.authService.getUser()?.isSSOUser;
    let lang = localStorage.getItem('lang');
      this.authService.logOut().subscribe(
        _ => {
          if (isSSOUser) {
            window.location.href = `${environment.donorSiteUrl}/main/sso-login?loggedout=true&isSSOUser=${isSSOUser}&lang=${lang}`;
          } else {
            window.location.href = `${environment.donorSiteUrl}?loggedout=true&lang=${lang}`;
          }
        }
      );
  }

  
}
